import { tryOnMounted, watchOnce } from '@vueuse/core'
import { useUserInfo } from '@/composition/useMember'
import { useGtm } from '@/composition/useGtm'
import { GtmEventMap } from '@/view-models/gtm'

export function usePageView(eventData: MaybeRef<GtmEventMap | Record<string, unknown>>, isReady: MaybeRef<boolean> = true) {
  const { userInfo } = useUserInfo()
  const { sendGtmEvent } = useGtm()

  const sendPageViewEvent = () => {
    sendGtmEvent(unref(eventData))
    if (userInfo.value) {
      sendGtmEvent(unref(eventData), true)
    }
  }

  // `tryOnMounted` is for user who viewed else page first, then go here
  tryOnMounted(() => {
    if (!unref(isReady)) return
    sendPageViewEvent()
  })

  // `watchOnce` is for user who views this page first
  watchOnce(userInfo, (newUserInfo, oldUserInfo) => {
    if (!oldUserInfo && newUserInfo && unref(isReady)) {
      sendGtmEvent(unref(eventData), true)
    }
  })

  // send once async data resolves
  watchOnce(
    () => unref(isReady),
    ready => {
      if (ready) sendPageViewEvent()
    }
  )
}
